export const selectProvision = (state) => state.dashboard.provision;

export const selectCurrentFunctionKey = (state) => state.dashboard?.currentFunctionKey;

export const selectShiftId = (state) => state.dashboard?.shiftId;

export const selectCurrentTimeInMS = (state) => state.dashboard?.dateTimeInMs;

export const selectEmployeeShiftData = (state) => state.dashboard?.employeeShift;

export const selectCustomMappingData = (state) => state.dashboard?.customMappingData;